module.exports = __webpack_public_path__ + "static/media/Kinetic-Green.8b703d6b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Kinetic-Green.webp
// module id = 335
// module chunks = 0